import { css } from '@emotion/react'
import { Text, Theme, useTheme, VFlow } from 'bold-ui'
import { AccordionCompositeItem } from 'components/accordion/AccordionCompositeItem'
import { ConjuntoFatoresSdcDto } from 'graphql/types.generated'
import { Accordion } from 'react-accessible-accordion'

import { SdcFatorRiscoTable } from './SdcFatorRiscoTable'
import { SdcSecaoAlerta } from './SdcSecaoAlerta'

interface SdcSecaoAccordionProps {
  conjuntoFatoresSdc: ConjuntoFatoresSdcDto
}

export const SdcSecaoAccordion = ({ conjuntoFatoresSdc }: SdcSecaoAccordionProps) => {
  const theme = useTheme()

  const styles = createStyles(theme)

  return (
    <VFlow vSpacing={0.25}>
      <Accordion allowZeroExpanded allowMultipleExpanded>
        <VFlow vSpacing={1.5}>
          {!conjuntoFatoresSdc.fatoresVerificadosSdc.fatores.isEmpty() && (
            <AccordionCompositeItem
              header={<Text fontWeight='bold'>Fatores verificados pelo sistema</Text>}
              style={styles.borderStyle}
              accordionButtonContentStyle={styles.contentStyle}
              accordionItemStyle={styles.buttonStyle}
              body={
                <SdcSecaoAlerta
                  paddingConteudoHorizontal
                  paddingConteudoTop
                  conteudo={conjuntoFatoresSdc.fatoresVerificadosSdc.descricao}
                >
                  <div
                    css={css`
                      padding: 1rem;
                    `}
                  >
                    <SdcFatorRiscoTable rows={conjuntoFatoresSdc.fatoresVerificadosSdc.fatores} />
                  </div>
                </SdcSecaoAlerta>
              }
            />
          )}

          {conjuntoFatoresSdc.fatoresNaoVerificadosSdc && (
            <AccordionCompositeItem
              header={<Text fontWeight='bold'>Fatores não verificados pelo sistema</Text>}
              accordionButtonContentStyle={styles.contentStyle}
              accordionItemStyle={styles.buttonStyle}
              body={
                <SdcSecaoAlerta
                  paddingConteudoHorizontal
                  paddingConteudoTop
                  conteudo={conjuntoFatoresSdc.fatoresNaoVerificadosSdc}
                />
              }
              style={styles.borderStyle}
            />
          )}
        </VFlow>
      </Accordion>
    </VFlow>
  )
}

const createStyles = (theme: Theme) => ({
  contentStyle: css`
    background-color: transparent;
  `,
  buttonStyle: css`
    &:hover {
      background-color: transparent;
    }
  `,
  borderStyle: css`
    border: 0.063rem solid ${theme.pallete.gray.c80};
    border-radius: 2px;
  `,
})
